"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSitesListApiSchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
const siteItemApiResponseSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: (0, api_1.apiEntityTypeSchema)('sites'),
    attributes: zod_1.z.object({
        name: zod_1.z.string(),
        officeCount: zod_1.z.number().optional().default(0),
    }),
});
exports.getSitesListApiSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(siteItemApiResponseSchema);
